export default class GlobalHandler {
	viewHeight() {
		function calculateViewHeight() {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		}
		calculateViewHeight();
		window.addEventListener("resize", () => {
			calculateViewHeight();
		});
	}
}